export default __webpack_public_path__ + "static/logo_newcar-277f1048bf3ebfad0ee31d3aa55899c1.svg";